import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TRACCIATO_OVERWRITE_MODES, TracciatoOverwriteModes} from "../../../_helpers/TracciatoOverwriteMode";

@Component({
    selector: 'app-select-tracciati-overwrite-mode',
    templateUrl: './select-tracciati-overwrite-mode.component.html',
    styleUrls: ['./select-tracciati-overwrite-mode.component.scss'],
    standalone: false
})
export class SelectTracciatiOverwriteModeComponent {
  @Input() overwriteMode: TracciatoOverwriteModes;
  @Output() overwriteModeChange = new EventEmitter<TracciatoOverwriteModes>();
  tracciatoOverwriteModesItem = TRACCIATO_OVERWRITE_MODES;
  selectOverwriteMode = (e: SelectCustomEvent) => this.overwriteModeChange.emit(e.target.value);
}
